import React from 'react';
import { useIntl } from 'react-intl';
import styles from './profile-info-card.module.scss';

interface ProfileInfoCardProps {
    labelId: string;
    value?: React.ReactNode;
    emptyValue: string;
}

const ProfileInfoCard: React.FC<ProfileInfoCardProps> = ({ labelId, value, emptyValue }) => {
    const intl = useIntl();

    return (
        <div className={styles.profileCard}>
            <div className={styles.profileCardContent}>
                <span className={styles.profileCardLabel}>
                    {intl.formatMessage({ id: labelId })}:
                </span>
                <span className={styles.profileCardValue}>
                    {value || emptyValue}
                </span>
            </div>
        </div>
    );
};

export default ProfileInfoCard;
